const COUNTRY_CODES = {
    MX: {
        icon: 'icMexicoFlag',
        name: 'México'
    },
    US: {
        icon: 'icUSAFlag',
        name: 'Estados Unidos'
    }
};
export default COUNTRY_CODES;
